import { render, staticRenderFns } from "./DoCard.vue?vue&type=template&id=fb2e47d0&"
import script from "./DoCard.vue?vue&type=script&lang=js&"
export * from "./DoCard.vue?vue&type=script&lang=js&"
import style0 from "./DoCard.vue?vue&type=style&index=0&id=fb2e47d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports